import { Playground } from 'docz';
import { Pagination } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Pagination,
  React
};